/**
 * Kategorie podatkowe wiersza rejestru VAT — zamknięty zbiór z FA(3) (podsumowanie VAT,
 * pola `P_13_*`). Wspólne dla backendu (walidator payloadu, CHECK w migracji 0158) i
 * frontu (dropdown w rejestrze VAT), dlatego mieszkają w paczce współdzielonej, nie w
 * dwóch kopiach.
 *
 * To NIE to samo co kategoria „ABCD" (`document_vat_register_entries.category_abcd`) —
 * ABCD to typ rejestru po stronie Symfonii FK (pole `Type`/`typabc`), a kategoria podatkowa
 * mówi, do której rubryki deklaracji wiersz należy. Dwie różne osie, oba pola są potrzebne.
 *
 * Zbiór ma 13 pozycji, nie 11 par: `P_14_nW` (VAT w PLN dla faktury walutowej) istnieje
 * tylko dla stawek 1–4, dlatego `vatInPln` rozróżnia te przypadki.
 */

export interface VatTaxCategoryDefinition {
  /** Kod przechowywany w bazie (`document_vat_register_entries.tax_category`). */
  code: string;
  /** Pole FA(3), do którego wiersz się sumuje — nośnik sensu, nie tylko etykieta. */
  fa3Field: string;
  /** Czy dla tej kategorii FA(3) przewiduje VAT przeliczony na PLN (`P_14_*nW`). */
  vatInPln: boolean;
}

export const VAT_TAX_CATEGORIES: readonly VatTaxCategoryDefinition[] = [
  { code: 'podstawowa', fa3Field: 'P_13_1', vatInPln: true },
  { code: 'obnizona_1', fa3Field: 'P_13_2', vatInPln: true },
  { code: 'obnizona_2', fa3Field: 'P_13_3', vatInPln: true },
  { code: 'taksowki', fa3Field: 'P_13_4', vatInPln: true },
  { code: 'oss', fa3Field: 'P_13_5', vatInPln: false },
  { code: 'zero_krajowa', fa3Field: 'P_13_6_1', vatInPln: false },
  { code: 'zero_wdt', fa3Field: 'P_13_6_2', vatInPln: false },
  { code: 'zero_eksport', fa3Field: 'P_13_6_3', vatInPln: false },
  { code: 'zwolniona', fa3Field: 'P_13_7', vatInPln: false },
  { code: 'poza_krajem', fa3Field: 'P_13_8', vatInPln: false },
  { code: 'uslugi_art100', fa3Field: 'P_13_9', vatInPln: false },
  { code: 'oo_krajowe', fa3Field: 'P_13_10', vatInPln: false },
  { code: 'marza', fa3Field: 'P_13_11', vatInPln: false },
] as const;

export const VAT_TAX_CATEGORY_CODES: readonly string[] = VAT_TAX_CATEGORIES.map((c) => c.code);

export function isVatTaxCategory(code: string): boolean {
  return VAT_TAX_CATEGORY_CODES.includes(code);
}
